import React from 'react';
import { makeStyles } from "@material-ui/core/styles";
import { useTranslation } from 'react-i18next';
import OrderDetailInfoTable from './OrderDetailInfoTable';
import { GetOrderArticleInfoForOrderDetailInfoTable } from '../../../Helpers/OrderInfoHelper'
import { GetOrderPaletInfoForOrderDetailInfoTable } from '../../../Helpers/OrderInfoHelper'
import OrderDetailToleranceInfoTable from './OrderDetailToleranceInfoTable';
import BOLImagesComponent from '../BOLImagesComponent';

export default function OrderDetailMainInfo(props) {
    const classes = useStyles();

    const { t } = useTranslation();

    return <div className={classes.main}>

        <div className={classes.upperContainer}>
            <div style={{ height: "60px" }}>
                <div style={{ width: "50%", float: "left" }}>
                    <div className={classes.client}>
                        {t("Client")}
            </div>
                    <div className={classes.flagstone}>
                        {props.productionOrder.customerName}
                    </div>
                </div>
                <div style={{ width: "50%", float: "left" }}>
                    <BOLImagesComponent bolMetaData={JSON.parse(props.productionOrder.bolMetaData).find(x => x.MetaDataType === 1).MetaData}></BOLImagesComponent>
                </div>
            </div>

            <div className={classes.leftTable}>
                <OrderDetailInfoTable rows={GetOrderArticleInfoForOrderDetailInfoTable(props.productionOrder.bomOut[0])}></OrderDetailInfoTable>
            </div>
            <div className={classes.rightTable}>
                <OrderDetailInfoTable rows={GetOrderPaletInfoForOrderDetailInfoTable(props.productionOrder.bomOut[0])}></OrderDetailInfoTable>
            </div>
        </div>
        <div className={classes.splitter}></div>
        <div className={classes.lowerContainer}>
            <OrderDetailToleranceInfoTable bomOut={props.productionOrder.bomOut[0]} {...props}></OrderDetailToleranceInfoTable>
        </div>
    </div>
}

const useStyles = makeStyles({
    client: {
        fontSize: "12px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        color: "#8D8D8D",
        display: "block",
    },
    flagstone: {
        fontSize: "22px",
        fontFamily: "Lato, sans-serif",
        fontWeight: 'medium',
        color: "#020100",
        display: "block",
    },
    leftTable: {
        width: "50%",
        float: "left"
    },
    rightTable: {
        width: "50%",
        float: "left",
        paddingLeft: "15px",
        boxSizing: "border-box"
    },
    main: {
        backgroundColor: "white",
        borderRadius: "5px"
    },
    upperContainer: {
        height: "160px",
        padding: "20px"
    },
    lowerContainer: {
        height: "130px",
        padding: "20px",
        paddingTop: "5px"
    },
    splitter: {
        height: "1px",
        marginLeft: "20px",
        marginRight: "20px",
        backgroundColor: "#EFEFEF"
    }

});